import { render, staticRenderFns } from "./MallDownload.vue?vue&type=template&id=522b8e0a&"
import script from "./MallDownload.vue?vue&type=script&lang=js&"
export * from "./MallDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports